import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import {
  CheckoutService,
  CheckoutData
} from '../../../service/checkout.service';

@Component({
  selector: 'app-checkout-sucesso',
  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl: './checkout-sucesso.component.html',
  styleUrl: './checkout-sucesso.component.css'
})
export class CheckoutSucessoComponent implements OnInit {

  dados: CheckoutData | null = null;

  reservaId: number | null = null;


  constructor(
    private checkoutService: CheckoutService,
    private router: Router
  ) {}


  ngOnInit(): void {

    this.dados = this.checkoutService.dados;

    this.reservaId =
      (this.dados as (CheckoutData & {
        reservaId?: number;
      }) | null)?.reservaId ?? null;

  }

  formatarData(data: string | undefined): string {

    if (!data) {
      return '';
    }

    const partes = data.split('-');

    if (partes.length !== 3) {
      return data;
    }

    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  get valorTotal(): number {

    return this.dados?.valorTotal || 0;
  }

  voltarInicio(): void {

    this.checkoutService.limpar();

    this.router.navigate([
      '/'
    ]);

  }

}
